export default {
  methods: {
    getFormattedDuration(from, to, placeholder) {
      const diff = this.$moment.duration(this.$moment(to).diff(from));
      if (!diff.isValid()) {
        return placeholder || '-';
      }
      const hours = diff.get('hours');
      const minutes = diff.get('minutes');
      const seconds = diff.get('seconds');
      let formattedString = '';
      if (hours > 0) {
        formattedString += `${hours}h `;
      }
      return `${formattedString}${minutes}m ${seconds}s`;
    },
    formatDate(date, placeholder) {
      const momentDate = this.$moment.utc(date);
      return momentDate.isValid() ? momentDate.local().format('DD-MM-YYYY HH:mm:ss') : (placeholder || '-');
    },
    formatDateSpecific(date, format, placeholder) {
      const momentDate = this.$moment.utc(date);
      return momentDate.isValid() ? momentDate.local().format(format) : (placeholder || '-');
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/dateMixin.js